export default {
  name: 'emailPush',
  // 邮件传播
  // 邮件推送-获取任务列表
  GetPushTaskList: {
    url: '/das-api/vas/push/task/pushTaskList'
  },
  // 邮件推送-新建更新推送任务
  NewEditTaskInfo: {
    url: '/das-api/vas/push/task/saveTaskInfo'
  },
  // 邮件推送-删除推送任务
  DeleteTaskInfo: {
    url: '/das-api/vas/push/task/deleteTaskInfo'
  },
  // 邮件推送-获取推送学者人数
  GetSendMemberSize: {
    url: '/das-api/vas/push/task/getPreparePushMagHistoryAuthorNumber'
  },
  //邮件推送-自助推送
  TaskSend: {
    url: '/das-api/vas/push/task/send'
  },
  //邮件推送-发送验证码
  SendReceiverMessage: {
    url: '/das-api/vas/AlidayuVerifycode/sendReceiverMessage'
  },
  //邮件推送-删除每期文章
  DeleteIssueArticle: {
    url: '/das-api/VAS/push/task/delete'
  },
  //邮件推送-每期文章排序
  IssueUpOrBottom: {
    url: '/das-api/VAS/push/task/sequence'
  },
  //邮件推送-上传每期文章封面
  UploadIssueCover: {
    url: '/das-api/VAS/push/task/saveCover'
  },
  //邮件推送-发件邮箱管理-查询刊物推送邮箱列表
  GetEmailList: {
    url: '/das-api/mag/email/list'
  },
  //邮件推送-发件邮箱管理-修改本刊任务连续推送天数
  UpdatePushContinueDay: {
    url: '/das-api/vas/mag/updatePushContinueDay'
  },
  //邮件推送-发件邮箱管理-新增邮箱确定/修改
  SaveNewEmail: {
    url: '/das-api/mag/email/save'
  },
  //邮件推送-发件邮箱管理-删除邮箱
  DeleteEmail: {
    url: '/das-api/mag/email/delete'
  },
  //邮件推送-发件邮箱管理-邮箱列表上移下移
  EmailUpOrBottom: {
    url: '/das-api/mag/email/sequence'
  },
  //邮件推送-发件邮箱管理-邮箱列表每个邮箱的收件邮箱列表
  ExportEmailList: {
    url: '/das-api/mag/email/email/list'
  },
  //邮件推送-发件邮箱管理-邮箱列表每个邮箱的收件邮箱列表删除数据
  DeleteExportEmailListItem: {
    url: '/das-api/mag/email/email/delete'
  },
  //邮件推送-发件邮箱管理-刊物推送邮箱获取刊物推送作者数
  Refresh: {
    url: '/das-api/mag/email/refresh'
  },
  //邮件推送-本刊模板-新建保存修改模板
  SaveEmailModuleSettings: {
    url: '/das-api/push/template/save'
  },
  //邮件推送-本刊模板-获取模板列表
  GetEmailModuleList: {
    url: '/das-api/push/template/list'
  },
  //邮件推送-本刊模板-更新模板封面图
  UpdateTemplateCover: {
    url: '/das-api/push/template/updateCoverId'
  },
  //邮件推送-本刊模板-更新模板封面图
  DeleteEmailTemplate: {
    url: '/das-api/push/template/delete'
  },
  //邮件推送-本刊模板-更新默认模板
  UpdateIsDefaulUt: {
    url: '/das-api/push/template/updateIsDefault'
  },
  //邮件推送-任务管理-推送任务更新推送模板
  UpdateTemplateId: {
    url: '/das-api/vas/push/task/updateTemplateId'
  },
  //邮件推送-基础配置-期刊邮件推送查询
  GetEmailConfig: {
    url: '/das-api/push/mag/config/getByMagId'
  },
  //邮件推送-基础配置-期刊邮件推送改变
  UpdateSendCount: {
    url: '/das-api/push/mag/config/update'
  },
  //邮件推送-基础配置-学者打开率设置
  UpdateOpenPercent: {
    url: '/das-api/push/mag/config/updateOpenPercent'
  },
  //邮件推送-预览邮件
  GetTemplateHtml5Info: {
    url: '/das-api/vas/push/task/getTemplateHtml5Info'
  },
  //邮件推送-学者推送类型设置
  UpdatePushType: {
    url: '/das-api/vas/push/task/updatePushType'
  },
  //邮件推送-任务管理-推送任务推送学者初始化
  PreparePushMagHistoryAuthor: {
    url: '/das-api/vas/push/task/preparePushMagHistoryAuthor'
  },
  //邮件推送-推送任务学者分析检查是否需要初始化
  CheckPreparePushMagHistoryAuthor: {
    url: '/das-api/vas/push/task/checkPreparePushMagHistoryAuthor'
  },
  //邮件推送-推送任务学者分析初始化状态获取
  CheckPushMagHistoryAuthorTime: {
    url: '/das-api/vas/push/task/checkPushMagHistoryAuthorTime'
  },
  //邮件推送-任务管理申请导出学者
  GetApplyExportPushHistoryImportAuthorExcel: {
    url: '/das-api/vas/push/task/applyExportPushHistoryImportAuthorExcel'
  },
  //邮件推送-查询计算目标学者消息提示
  PreparePushMagHistoryAuthorMessage: {
    url: '/das-api/vas/push/task/preparePushMagHistoryAuthorMessage'
  },
  //邮件推送-自定义推送学者-查询任务自定义推送设置
  GetCustomScholar: {
    url: '/das-api/push/set/get'
  },
  //邮件推送-自定义推送学者-获取历史推送版本列表
  GetHistoryVersions: {
    url: '/das-api/vas/send/author/getSendVersion'
  },
  //邮件推送-自定义推送学者-推送历史版本接口带类型
  GetSendVersionGroupType: {
    url: '/das-api/vas/send/author/getSendVersion/groupType'
  },
  //邮件推送-自定义推送学者-获取上一次同类型任务ID
  FindLastTask: {
    url: '/das-api/push/set/findLastTask'
  },
  //邮件推送-自定义推送学者-根据时间戳获取参数
  GetVersion: {
    url: '/das-api/push/set/getVersion'
  },
  //邮件推送-自定义推送学者-设置任务自定义推送设置
  SetCustomScholar: {
    url: '/das-api/push/set/updateById'
  },
  //邮件推送-自定义推送学者-学者领域tree图
  GetCategory: {
    url: '/das-api/vas/push/history/category/categoryTree'
  },
  //邮件推送-自定义推送学者-任务推送设置领域
  SetCategory: {
    url: '/das-api/vas/push/history/category/set'
  },
  //邮件推送-自定义推送学者-设置领域获取回显
  GetSetCategory: {
    url: '/das-api/vas/push/history/category/getTreeChoice'
  },
  //邮件推送-自定义推送学者-各推送类型默认设置
  GetPushTypeDefault: {
    url: '/das-api/push/set/getDefault'
  },
  //邮件推送-自定义推送学者-任务默认中图分类id树获取
  GetDefault: {
    url: '/das-api/vas/push/history/category/getDefault'
  },
  //邮件推送-邮件内容配置-获取推送任务模板类型
  GetSetType: {
    url: '/das-api/push//template/getSetType'
  },
  //邮件推送-邮件内容配置-获取推送任务模板
  GetTemplate: {
    url: '/das-api/push/history/template/getList'
  },
  //邮件推送-邮件内容配置-新增每期论文
  SaveIssueArticle: {
    url: '/das-api/vas/push/article/save'
  },
  //邮件推送-查看学者-下载学者状态查询
  GetDownloadAuthorStatus: {
    url: '/das-api/vas/exporttask/getByKeyValue'
  },
  //邮件推送-查看学者-申请导出预推送学者
  ApplyDownloadAuthor: {
    url: '/das-api/vas/push/task/applyExportPushHistoryImportAuthorExcel'
  },
  //邮件推送-邮件内容配置-保存推送任务模板
  SaveTemplate: {
    url: '/das-api/push/history/template/save'
  },
  //邮件推送-基础配置-期刊邮件推送期刊分类设置
  GetMagZxsList: {
    url: '/das-api/vas/push/mag/config/searchMagZxsCat'
  },
  //邮件推送-基础配置-期刊邮件推送期刊选择查询
  GetMagChioceList: {
    url: '/das-api/vas/push/mag/mag/set/getChioce'
  },
  //邮件推送-基础配置-期刊邮件推送机构选择查询
  GetOrgChioceList: {
    url: '/das-api/vas/push/mag/org/set/getChioce'
  },
  //邮件推送-基础配置-期刊邮件推送期刊设置
  SetMagChioce: {
    url: '/das-api/vas/push/mag/mag/set/set'
  },
  //邮件推送-基础配置-期刊邮件推送期刊查询
  GetMagChioce: {
    url: '/das-api/vas/push/mag/mag/set/get'
  },
  //邮件推送-基础配置-期刊邮件推送机构设置
  SetOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/set'
  },
  //邮件推送-基础配置-期刊邮件推送机构查询
  GetOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/get'
  },
  // 邮件推送-基础配置-删除推送机构
  DeleteOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/delete'
  },
  //邮件推送-学者数据测评-整期论文引证分页统计
  GetIssueArticleCitation: {
    url: '/das-api/vas/article/getIssueArticleCitation'
  },
  //邮件推送-学者数据测评-整期论文引证数量统计
  SumIssueArticleCitation: {
    url: '/das-api/vas/article/sumIssueArticleCitation'
  },
  //邮件推送-学者数据测评-被引文献
  GetCountRootArticleCitations: {
    url: '/das-api/vas/article/countRootArticleCitations'
  },
  //邮件推送-学者数据测评-引证期刊
  GetCountMagCitations: {
    url: '/das-api/vas/article/countMagCitations'
  },
  //邮件推送-学者数据测评-被引机构
  GetCountRootMagOrg: {
    url: '/das-api/vas/article/countRootMagOrg'
  },
  //邮件推送-学者数据测评-引证机构
  GetCountCitationsMagOrg: {
    url: '/das-api/vas/article/countCitationsMagOrg'
  },
  //邮件推送-学者数据测评-被引文献关键词
  GetCountRootArticleKeywords: {
    url: '/das-api/vas/article/countRootArticleKeywords'
  },
  //邮件推送-学者数据测评-引证文献关键词
  GetCountCitatinsArticleKeywords: {
    url: '/das-api/vas/article/countCitatinsArticleKeywords'
  },
  //邮件推送-邮件内容配置-推送任务添加期刊推送模板
  SetHistoryTemplate: {
    url: '/das-api/push/history/template/set'
  },
  //邮件推送-邮件内容配置-查询推送任务模板详情
  GetHistoryTemplateDetail: {
    url: '/das-api/push/history/template/getById'
  },
  //邮件推送-邮件内容配置-查询推送任务模板设置类型
  GetHistoryTemplateSetType: {
    url: '/das-api/push/history/template/getSetTypeById'
  },
  //邮件推送-邮件内容配置-删除推送任务模板
  DeleteHistoryTemplate: {
    url: '/das-api/push/history/template/delete'
  },
  //邮件推送-邮件内容配置-更新推送任务模板选中状态
  UpdateHistoryTemplateChoose: {
    url: '/das-api/push/history/template/updateIsChoice'
  },
  //邮件推送-邮件内容配置-新增推送任务模板
  AddHistoryTemplate: {
    url: '/das-api/push/history/template/add'
  },
  //邮件推送-学者数据测评分析报告-整期论文引证数量统计
  GetSumIssueArticleCitation: {
    url: '/das-api/vas/article/sumIssueArticleCitation'
  },
  // 邮件推送-学者数据测评分析报告-高引用期刊（引用次数Top10）学者覆盖情况
  GetReferenceAuthorCount: {
    url: '/das-api/vas/statistics/referenceAuthorCount'
  },
  // 邮件推送-学者数据测评分析报告-高引证期刊（引证次数Top10）学者覆盖情况
  GetCitationAuthorCount: {
    url: '/das-api/vas/statistics/citationAuthorCount'
  },
  // 邮件推送-学者数据测评分析报告-本刊发文机构（发文top10）学者储备统计
  GetInstitutionAuthorCount: {
    url: '/das-api/vas/statistics/institutionAuthorCount'
  },
  // 邮件推送-学者数据测评分析报告-引用机构（引用次数top10）学者储备统计
  GetReferenceInstitutionAuthorCount: {
    url: '/das-api/vas/statistics/referenceInstitutionAuthorCount'
  },
  // 邮件推送-学者数据测评分析报告-引证机构（引证次数top10）学者储备统计
  GetCitationInstitutionAuthorCount: {
    url: '/das-api/vas/statistics/citationInstitutionAuthorCount'
  },
  // 邮件推送-学者数据测评分析报告-近五年高被引文献（Top10）的引证文献作者覆盖统计
  GetcountRootArticleCitationsAuthorCount: {
    url: '/das-api/vas/article/countRootArticleCitationsAuthorCount'
  },
  // 邮件推送-期刊邮件精准推送设置查询
  GetAccurateConfigList: {
    url: '/das-api/push/mag/accurate/config/getByMagId'
  },
  // 邮件推送-期刊邮件精准推送设置保存
  SaveAccurateConfig: {
    url: '/das-api/push/mag/accurate/config/save'
  },
  // 参考文献分析
  ReferenceArticleAnalysis: {
    url: '/das-api/vas/push/task/referenceArticleAnalysis'
  },
  // 推送采集分析
  ApplyExportTaskMagPush: {
    url: '/das-api/VAS/push/task/applyExportTaskMagPush'
  },
  // 导出任务通过key value查询
  getByKeyValue: {
    url: '/das-api/vas/exporttask/getByKeyValue'
  },
  // 邮件推送-预览lable标签页
  getTemplateInfoLabel: {
    url: '/das-api/vas/push/task/getTemplateInfoLabel'
  },
  // 邮件推送-iframe页面
  getTemplateHtml5InfoAndType: {
    url: '/das-api/vas/push/task/getTemplateHtml5InfoAndType'
  },
  // 邮件推送-更新语言
  updateLanguage: {
    url: '/das-api/vas/push/task/updateLanguage'
  },
  // 邮件推送-更新链接优先级
  updateHtmlOrder: {
    url: '/das-api/vas/push/task/updateHtmlOrder'
  },
  // 邮件推送-配置推送期刊机构阈值
  updatePushMagCustomValue: {
    url: '/das-api/push/mag/config/updatePushMagCustomValue'
  },
  // 邮件推送-查看阈值
  getSeuilSetting: {
    url: '/das-api/vas/push/getLimitNumber'
  },
  // 邮件推送-年度报告生成
  generateAnnualReport: {
    url: '/das-api/vas/annualReport/v2/exportAnnualReport'
  },
  // 邮件推送-年度报告生成状态查询
  getAnnualReportStatus: {
    url: '/das-api/vas/annualReport/v2/getReportStatus'
  },
  // 邮件推送-新版年度报告生成
  generateAnnualReport2: {
    url: '/das-api/vas/annualReport/v2/exportAnnualReport2'
  },
  // 近十年论文栏目分布接口
  getArticleColumnDistribution: {
    url: '/das-api/vas/annualReport/v2/articleColumnDistribution'
  },
  // 历年知网论文数量分布
  getArticleCountByYear: {
    url: '/das-api/vas/annualReport/v2/articleCountByYear'
  },
  // 历年影响因子接口
  getMagFactorByYear: {
    url: '/das-api/vas/annualReport/v2/magFactorByYear'
  },
  // 近十年学科分布接口
  getArticleTopicNameStatistic: {
    url: '/das-api/vas/annualReport/v2/articleTopicNameStatistic'
  },
  // 近十年文献关键词接口
  getArticleKeywordStatistic: {
    url: '/das-api/vas/annualReport/v2/articleKeywordStatistic'
  },
  //查询自定义关键词
  GetCustomKeyword: {
    url: '/das-api/push/set/getCustomKeyword'
  },
  // 自定义推送关键词学者
  SetCustomKeyword: {
    url: '/das-api/push/set/setCustomKeyword'
  },
  //查询推送期刊中信所分类（过滤）
  GetFilter: {
    url: '/das-api/push/set/getFilter'
  },
  // 设置推送期刊中信所分类（过滤）
  SetZxsFilter: {
    url: '/das-api/push/set/setZxsFilter'
  },
  // 获取推送期刊范围
  GetAllMagFilter: {
    url: '/das-api/push/set/getAllMagFilter'
  },
  //年度基金论文量
  GetfundArticleCount: {
    url: '/das-api/vas/magPortrait/fundArticleCount'
  }
}
